import { categories } from "../../../mocks/trendData";

const sections = [
  {
    title: "栏目",
    links: categories.filter((c) => c !== "全部").map((c) => ({ label: c, href: "#category" })),
  },
  {
    title: "快速导航",
    links: [
      { label: "今日热榜", href: "#hot" },
      { label: "连载瓜追踪", href: "#serial" },
      { label: "最新动态", href: "#latest" },
      { label: "事件全记录", href: "#record" },
    ],
  },
  {
    title: "帮助",
    links: [
      { label: "关于我们", href: "#about" },
      { label: "常见问题", href: "#faq" },
      { label: "联系我们", href: "#contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-accent-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="grid h-9 w-9 place-items-center rounded-lg bg-accent-500 text-accent-950">
                <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-white">吃瓜合集</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-accent-200">
              把散落各处的连载瓜、系列爆料按时间线整理成串。
              事件全记录持续更新，老板吃瓜更省心。
            </p>
          </div>

          {sections.map((s) => (
            <div key={s.title}>
              <h4 className="font-heading text-sm font-semibold text-white">{s.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {s.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-accent-200 transition-colors hover:text-white"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-accent-700/60 pt-6 sm:flex-row">
          <p className="text-xs text-accent-300">
            © {new Date().getFullYear()} 吃瓜合集 · 娱乐热点与事件追踪内容平台
          </p>
          <div className="flex items-center gap-4 text-accent-300">
            <a
              href="#contact"
              className="inline-flex items-center gap-1.5 text-xs transition-colors hover:text-white"
            >
              <i className="ri-mail-line" aria-hidden="true"></i> 联系我们
            </a>
            <a
              href="#top"
              className="inline-flex items-center gap-1.5 text-xs transition-colors hover:text-white"
            >
              <i className="ri-arrow-up-line" aria-hidden="true"></i> 返回顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}